import { ConnectionState, IAgoraRTCRemoteUser } from "agora-rtc-sdk-ng";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAgora } from "../../helpers/agoraProvider";
import { AGORA_APP_ID } from "../../helpers/config";
import { USER_TYPES } from "../../helpers/constant";
import { IAgoraTrack } from "../../helpers/types";
import { authService } from "../../services";
import AgoraRTMPPlayerComponent from "../AgoraRTMPPlayerComponent";
import LiveJoinWaitComponent from "../LiveJoinWaitComponent";

type props = {
  sessionId: string | null;
  remoteId: string | null;
  onStreamStatusChange?: Function;
  unSubscribed?: Function;
  isBlur?: boolean;
  isDisableAudio?: boolean;
  index?: number;
  ref: React.Ref<any>;
  isFromMobile: boolean;
};

const LiveRTMP: React.FC<props> = React.forwardRef<any, props>(
  ({ sessionId, remoteId, onStreamStatusChange, unSubscribed, isBlur, isDisableAudio, index, isFromMobile }: props, ref: React.Ref<any>) => {
    const { client } = useAgora();
    const { t } = useTranslation();
    const userId = authService.getId();
    const [tracks, setTracks] = useState<IAgoraTrack | null>(null);
    const clientRef = useRef<any>();
    const [isStarted, setIsStarted] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const currentUser = authService.getUser();
    const watermarkText = currentUser.username;

    const join = async (token: string) => {
      if (!client || !AGORA_APP_ID || !sessionId) {
        return handleError(t("something-want-wrong") + " " + t("try-again-later"));
      }

      await client.join(AGORA_APP_ID, sessionId, token, null);
    };

    const leave = () => {
      clientRef.current?.uid && clientRef.current.leave();
      setTracks(null);
      if (clientRef.current?.remoteUsers) {
        clientRef.current.remoteUsers.forEach((remoteUser: any) => {
          remoteUser.audioTrack.stop();
        });
      }
    };

    const subscribe = async (user: IAgoraRTCRemoteUser, mediaType: "audio" | "video") => {
      if (!client) {
        // console.log("subscribe ", client);
        return handleError(t("something-want-wrong") + " " + t("try-again-later"));
      }
      await client.subscribe(user, mediaType);

      if (!client.remoteUsers) {
        // console.log("removte users ", client.remoteUsers);

        return handleError(t("something-want-wrong") + " " + t("try-again-later"));
      }

      const remoteUser = client.remoteUsers[0];

      if (mediaType === "audio" && remoteUser.audioTrack) {
        if (!isDisableAudio) {
          remoteUser.audioTrack.play();
        }
      }
      if (mediaType === "video" && remoteUser.videoTrack) setTracks({ tracks: [remoteUser.videoTrack] });

      setIsStarted(true);
      onStreamStatusChange && onStreamStatusChange(true);
    };

    const unSubscribe = (user: IAgoraRTCRemoteUser, mediaType: "audio" | "video") => {
      if (mediaType === "video") {
        clientRef.current?.uid && clientRef.current.leave();
        const remoteUser = user.uid === remoteId;
        if (remoteUser) {
          setTracks(null);
        }
        if (clientRef.current?.remoteUsers) {
          clientRef.current.remoteUsers.forEach((remoteUser: any) => {
            remoteUser.audioTrack.stop();
          });
        }
        onStreamStatusChange && onStreamStatusChange(false);
        const stats = clientRef.current?.getRTCStats();
        unSubscribed && unSubscribed(stats?.Duration);
        clientRef.current = null;
      }
    };

    const handleError = (error: string) => {
      setErrorMessage(error);
    };

    const connectionStateChanged = (state: ConnectionState) => {};

    useEffect(() => {
      clientRef.current = client;

      if (!client) return;
      client.on("user-published", subscribe);
      client.on("user-unpublished", unSubscribe);
      client.on("connection-state-change", connectionStateChanged);
    }, [client, remoteId]);

    useEffect(() => {
      return () => {
        leave();
      };
    }, []);

    // // Handle orientation changes and fullscreen behavior
    // useEffect(() => {
    //   const handleOrientationChange = () => {
    //     const newOrientation = window.screen.orientation.type;

    //        const videoElement = document.querySelector('.video-container');

    //       if (newOrientation.startsWith("landscape")) {
    //         // Enter fullscreen when in landscape mode
    //         if (videoElement && videoElement.requestFullscreen) {
    //           videoElement.requestFullscreen();
    //         } else if ((videoElement as any).webkitEnterFullscreen) {
    //           // For Safari
    //           (videoElement as any).webkitEnterFullscreen();
    //         }
    //       } else if (newOrientation.startsWith("portrait")) {
    //         // Exit fullscreen when in portrait mode
    //         if (document.fullscreenElement) {
    //           document.exitFullscreen();
    //         } else if ((document as any).webkitExitFullscreen) {
    //           // For Safari
    //           (document as any).webkitExitFullscreen();
    //         }
    //       }
    //   };

    //   window.screen.orientation.addEventListener("change", handleOrientationChange);

    //   // Cleanup event listener on component unmount
    //   return () => {
    //     window.screen.orientation.removeEventListener("change", handleOrientationChange);
    //   };
    // }, [ref]);

    React.useImperativeHandle(ref, () => ({
      join,
      leave,
      handleError,
    }));

    return isStarted ? (
      <>
        {/* <Watermark content={[watermarkText, "www.twizz.com"]} className="live-watermark" font={{ fontSize: 16, color: "rgba(255, 255, 255, 0.5)" }} /> */}
        <AgoraRTMPPlayerComponent tracks={tracks?.tracks || []} isBlur={isBlur} index={index} isFromMobile={isFromMobile} />
      </>
    ) : (
      <LiveJoinWaitComponent type={USER_TYPES.FAN} errorMessage={errorMessage} />
    );
  }
);

export default LiveRTMP;
